import { EntityType, ISearchResult } from "types";
import { HorizontalTeaserProps, LabelProps } from "components";
import { convertMinutesToDate, getToolTypeIcon } from "utils";
import { i18nService } from "services";

const getMeta = (result: ISearchResult) => {
  const publishedOn = i18nService.copy["siteSearch.publishedOn"];
  const publishedDate = convertMinutesToDate(+result.document.created);

  switch (result.document.bundle) {
    case EntityType.article:
      return `${publishedOn} ${publishedDate}`;
    case EntityType.event: {
      const timestamps = result.document.event_timestamps;

      if (!timestamps) return undefined;

      let days = timestamps.slice().sort();
      const nbDays = days.length;

      if (!nbDays) return undefined;

      const firstDay = convertMinutesToDate(+days[0]);
      const lastDay = convertMinutesToDate(+days[nbDays - 1]);

      const till = i18nService.copy["siteSearch.eventTill"];
      const startsOn = i18nService.copy["siteSearch.eventStartsOn"];

      switch (result.document.event_type) {
        case "one-day-event":
          return firstDay;
        case "multi-day-event":
          return `${firstDay} ${till} ${lastDay}`;
        case "multi-day-event-non-consecutive":
          return `${startsOn} ${firstDay}`;
        default:
          return undefined;
      }
    }
    default:
      return undefined;
  }
};

const getMediaLabel = (result: ISearchResult): LabelProps | undefined => {
  switch (result.document.bundle) {
    case EntityType.tool:
      if (!result.document.toolType) return undefined;

      const { key, label } = result.document.toolType;

      if (!label) return undefined;

      return {
        Icon: getToolTypeIcon(key),
        text: label,
      };
    default:
      return undefined;
  }
};

const getTeaserType = (result: ISearchResult): string | undefined => {
  switch (result.document.bundle) {
    case EntityType.tool:
      return result.document.toolType?.key || undefined;
    default:
      return undefined;
  }
};

const getBundleType = (result: ISearchResult): string | undefined => {
  switch (result.document.bundle) {
    case EntityType.tool:
      return '(tool)';
    case EntityType.dossier:
      return '(dossier)';
    default:
      return undefined;
  }
};

export const normalizeSearchResult = (
  result: ISearchResult
): HorizontalTeaserProps => {
  return {
    url: result.document.url,
    title: result.document.title,
    intro: result.highlights.intro || result.document.intro,
    meta: getMeta(result),
    image: result.document.metaImage,
    breadcrumbs: result.document.breadcrumbs,
    mediaLabel: getMediaLabel(result),
    teaserType: getTeaserType(result),
    bundle: getBundleType(result),
  };
};
